/**
 * @description 省市区(多级选中)
 * @deprecated 2019年11月6日
 * @create by lorry
 */
<template>
  <div class="custom-province"
    ref="wrap"
    @keydown.prevent
    @keyup.prevent
    @keyup.down="keydownHandle"
    @keyup.up="keyupHandle"
    @keyup.enter.prevent="keyenterHandle"
    @keyup.left="keyleftHandle"
    @keyup.right="keyrightHandle"
      v-clickout="hideModal">
    <div class="cp-input"
         @click="focus">
      <el-input class="el-select el-select--small"
        :placeholder="placeholder"
        :disabled="disabled"
        :value="valueInput"
        :title="valueInput"
        :name="name"
        readonly
        :validate-event="false"
        clearable>
        <i slot="suffix"
           class="el-input__icon el-icon-arrow-down"
           :class="isShow ? 'el-select__caret' : ''"></i>
        <i v-show="!disabled && valueInput" slot="suffix"
           @click="clearInput"
           class="el-icon-circle-close"></i>
      </el-input>
    </div>
    <el-collapse-transition>
      <div class="cp-modal"
          v-show="isShow">
        <div class="popper__arrow"></div>
        <div class="cpm-ul">
          <template v-for="(item, index) in initData">
            <div ref="pList"
                :key="item.id"
                v-if="index < showLevel"
                @click="clickTab(index)"
                class="cpml-li"
                :class="[item.isActive ? 'isActive' : '', item.disable ? 'disable' : '']">{{item.name}}</div>
          </template>
          <div class="cpml-line"
              :style="'width:' + lineWidth + 'px;' + 'transform:translateX('+ lineLeftW + 'px)'"></div>
        </div>
        <div class="cpm-content">
          <el-scrollbar ref="scrollbar" wrap-class="base-address-cader__wrap">
            <template v-if="typeClass === 0">
              <div class="cpmc-li"
                  v-if="isAll"
                  @click="selectAllProvince"
                  :class="value === 0 ? 'isSelectActive' : ''">{{$lang('全部')}}</div>
              <div class="cpmc-li"
                  ref="cmpcli"
                  v-for="(item, index) in provinceList"
                  @click="selectListClick(item.id)"
                  :class="item.isSelectActive ? 'isSelectActive' : index === provinceIndex ? 'hover-item' : ''"
                  :key="item.id">{{item.nativeName}}</div>
            </template>
            <template v-if="typeClass === 1">
              <div class="cpmc-li"
                  v-if="isAll"
                  @click="selectAllCity"
                  :class="isAllCity ? 'isSelectActive' : ''">{{$lang('全部')}}</div>
              <div class="cpmc-li"
                  ref="cmpcli"
                  v-for="(item, index) in cityList"
                  @click="selectListClick(item.id)"
                  :class="item.isSelectActive ? 'isSelectActive' : index === cityIndex ? 'hover-item' : ''"
                  :key="item.id">{{item.nativeName}}</div>
                  <span class="el-icon-loading" v-show="!cityList.length"></span>
            </template>
            <template v-if="typeClass === 2">
              <div class="cpmc-li"
                  ref="cmpcli"
                  v-for="(item, index) in areaList"
                  @click="selectListClick(item.id)"
                  :class="item.isSelectActive ? 'isSelectActive' : index === areaIndex ? 'hover-item' : ''"
                  :key="item.id">{{item.nativeName}}</div>
                  <span class="el-icon-loading" v-show="!areaList.length"></span>
            </template>
          </el-scrollbar>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
import { RESPONSE_CODE } from '@public/http/config'
import scrollIntoView from 'element-ui/src/utils/scroll-into-view'
import { sysArea } from '../pool'
export default {
  name: 'BaseAddressCader',
  props: {
    type: {
      type: String,
      default: 'search'
    },
    value: {
      type: [Object, Array, String, Number],
      default: () => []
    },
    // 展示层级 1 => 省 2 => 省市 3 => 省市区
    showLevel: {
      default: 3
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否能选全部
    isAll: {
      type: Boolean,
      default: false
    },
    // 默认值
    initAddressData: {
      type: Object,
      default: function () {
        return {
          formProps: {
            provinceIdProp: 'provinceId',
            provinceNameProp: 'provinceName',
            cityIdProp: 'cityId',
            cityNameProp: 'cityName',
            areaIdProp: 'areaId',
            areaNameProp: 'areaName'
          },
          defaultData: { a: 1 }
        }
      }
    }
  },
  computed: {
    placeholder() {
      const textMap = {
        1: this.$lang('请选择省'),
        2: this.$lang('请选择省市'),
        3: this.$lang('请选择省市区')
      }
      return textMap[this.showLevel]
    },
    citySplitStr() {
      return this.showLevel === 3 ? '/' : ''
    },
    provinceSplitStr() {
      return this.showLevel === 2 ? '/' : ''
    },
    isAllCity() {
      const { valueInput } = this
      return valueInput.split('/').length && valueInput.split('/').length === 2 && valueInput.split('/')[1] === '全部'
    },
    provinceId() {
      return this.addressInfo[this.initAddressData.formProps.provinceIdProp]
    },
    provinceName() {
      return this.addressInfo[this.initAddressData.formProps.provinceNameProp]
    },
    cityId() {
      return this.addressInfo[this.initAddressData.formProps.cityIdProp]
    },
    cityName() {
      return this.addressInfo[this.initAddressData.formProps.cityNameProp]
    },
    areaId() {
      return this.addressInfo[this.initAddressData.formProps.areaIdProp]
    },
    areaName() {
      return this.addressInfo[this.initAddressData.formProps.areaNameProp]
    },
    // 省市区hover index
    indexProp() {
      const { typeClass } = this
      const typeMap = {
        0: 'provinceIndex',
        1: 'cityIndex',
        2: 'areaIndex'
      }
      return typeMap[typeClass]
    },
    // 省市区列表
    listProp() {
      const { typeClass } = this
      const typeMap = {
        0: 'provinceList',
        1: 'cityList',
        2: 'areaList'
      }
      return typeMap[typeClass]
    }
  },
  watch: {
    disabled(newVal) {
      if (newVal) {
        this.isShow = false
      }
    },
    showLevel() {
      this.clickTab(0)
      this.$emit('input', '')
      this.$emit('change', '')
      this.$emit('changeAreaName', {})
      this.provinceList.forEach(item => {
        item.isSelectActive = false
      })
      this.valueInput = ''
    },
    'initAddressData.defaultData': {
      handler(val) {
        const { provinceIdProp, provinceNameProp, cityIdProp, cityNameProp, areaIdProp, areaNameProp } = this.initAddressData.formProps
        const data = {}
        data.provinceId = val[provinceIdProp]
        data.provinceName = val[provinceNameProp]
        data.cityId = val[cityIdProp]
        data.cityName = val[cityNameProp]
        data.areaId = val[areaIdProp]
        data.areaName = val[areaNameProp]
        this.addressInfo = data
        this.getProList()
      },
      deep: true
    },
    value: {
      handler(newVal) {
        if (newVal) {
          this.addressInfo = { ...newVal }
          // this.addressInfo = this.deepClone(newVal)
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      isShow: false,
      activeName: 'first',
      lineWidth: 0,
      lineLeftW: 10,
      initData: [{
        name: this.$lang('省份'),
        isActive: true,
        disable: false
      }, {
        name: this.$lang('城市'),
        isActive: false,
        disable: true
      }, {
        name: this.$lang('区县'),
        isActive: false,
        disable: true
      }],
      cacheAreaMap: {},
      provinceList: [],
      cityList: [],
      areaList: [],
      typeClass: 0,
      provinceIndex: -1,
      cityIndex: -1,
      areaIndex: -1,
      addressInfo: {
        // provinceId: '',
        // provinceName: '',
        // cityId: '',
        // cityName: '',
        // areaId: '',
        // areaName: ''
      },
      name: '',
      valueInput: '',
      suffixIcon: 'el-icon-arrow-down'
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 键盘下键事件
    keydownHandle() {
      const { indexProp, listProp, isShow } = this
      if (!isShow) return
      if (this[indexProp] < 0) {
        this[indexProp] = 0
        return
      }
      if (this[indexProp] === this[listProp].length - 1) {
        this[indexProp] = 0
        return
      }
      this[indexProp] += 1
      this.scrollToHover()
    },
    // 键盘上键事件
    keyupHandle() {
      const { indexProp, listProp, isShow } = this
      if (!isShow) return
      this[indexProp] -= 1
      if (this[indexProp] < 0) {
        this[indexProp] = this[listProp].length - 1
      }
      this.scrollToHover()
    },
    // 键盘左键事件 改变选择省市区
    keyleftHandle() {
      const activeIndex = this.initData.findIndex(item => item.isActive)
      if (activeIndex > 0) {
        this.clickTab(activeIndex - 1)
      }
    },
    // 键盘右键事件 改变选择省市区
    keyrightHandle() {
      const activeIndex = this.initData.findIndex(item => item.isActive)
      if (activeIndex < this.initData.length - 1) {
        this.clickTab(activeIndex + 1)
      }
    },
    // 回车事件
    keyenterHandle() {
      const { indexProp, listProp, typeClass, provinceIndex, cityIndex, areaIndex, isShow } = this
      if (!isShow) return
      if (typeClass === 0 && provinceIndex > -1 || typeClass === 1 && cityIndex > -1 || typeClass === 2 && areaIndex > -1) {
        this.selectListClick(this[listProp][this[indexProp]].id)
      }
    },
    scrollToHover() {
      this.$nextTick(() => {
        scrollIntoView(this.$refs.wrap.querySelector('.base-address-cader__wrap'), this.$refs.wrap.querySelector('.hover-item'))
        this.$refs.scrollbar.handleScroll()
      })
    },
    scrollToActive() {
      this.$nextTick(() => {
        scrollIntoView(this.$refs.wrap.querySelector('.base-address-cader__wrap'), this.$refs.wrap.querySelector('.isSelectActive'))
        this.$refs.scrollbar.handleScroll()
      })
    },
    // 回填省市区 value值是对象 监听会死循环
    fillBack() {
      this.getProList()
      if (!this.provinceId) {
        this.initData[1].disable = true
        this.initData[2].disable = true
      }
    },
    hideModal() {
      this.isShow = false
    },
    focus() {
      if (this.disabled) {
        return
      }
      this.isShow = !this.isShow
      this.getProList()
      if (this.provinceId) {
        this.initData.map(item => (item.disable = false))
        if (this.cityId && !this.areaId) {
          setTimeout(() => {
            this.clickTab(1)
          }, 0)
        }
        if (this.cityId && this.areaId) {
          setTimeout(() => {
            this.clickTab(2)
          }, 0)
        }
      }
    },
    selectAllCity() {
      this.hideModal()
      this.cityList.forEach(item => { item.isSelectActive = false })
      this.valueInput = this.valueInput.split('/')[0] + '/全部'
    },
    selectAllProvince() {
      this.hideModal()
      this.provinceList.forEach(item => { item.isSelectActive = false })
      this.valueInput = '全部'
      this.initData[1].disable = true
      this.$emit('input', 0)
      this.$emit('change', 0)
    },
    // 点击tab
    clickTab(index) {
      if (index === 0) {
        if (!this.initData || this.initData[0].disable || !this.$refs.pList || !this.$refs.pList[0]) return
        this.provinceIndex = this.provinceList.findIndex(item => item.isSelectActive)
        // 省
        const { clientWidth } = this.$refs.pList[0]
        this.lineLeftW = 10
        setTimeout(() => {
          this.lineWidth = clientWidth
        })
        this.selectList = this.provinceList
        this.typeClass = index
        this.initData.map(item => (item.isActive = false))
        this.initData[index].isActive = true
      } else if (index === 1) {
        if (this.initData[1].disable) return
        // 市
        const { clientWidth } = this.$refs.pList[1]
        this.lineLeftW = this.$refs.pList[1].getBoundingClientRect().x - this.$refs.pList[0].getBoundingClientRect().x + 10
        this.lineWidth = clientWidth
        this.selectList = this.cityList
        this.typeClass = index
        this.initData.map(item => (item.isActive = false))
        this.initData[index].isActive = true
      } else {
        if (this.initData[2].disable) return
        // 区
        const { clientWidth } = this.$refs.pList[2]
        this.lineLeftW = this.$refs.pList[2].getBoundingClientRect().x - this.$refs.pList[0].getBoundingClientRect().x + 10
        this.lineWidth = clientWidth
        this.selectList = this.areaList
        this.typeClass = index
        this.initData.map(item => (item.isActive = false))
        this.initData[index].isActive = true
      }
      this.scrollToActive()
    },
    // 获取省数据 （只请求一次数据）
    async getProList() {
      const fillBackProvince = () => {
        this.provinceList.map(item => (item.isSelectActive = false))
        if (this.cityId) {
          const obj = this.provinceList.find(item => item.id === this.provinceId)
          if (obj) obj.isSelectActive = true
          this.getCityList(this.provinceId)
          this.clearable = true
          if (!this.areaId) {
            this.valueInput = `${this.provinceName} / ${this.cityName} ${this.citySplitStr}`
          }
        } else {
          this.valueInput = this.provinceName ? `${this.provinceName} ${this.provinceSplitStr}` : ''
        }
      }
      if (this.provinceList.length) {
        fillBackProvince()
        return
      }
      const { data, code, msg } = await sysArea({ parentId: 1 })
      if (code === RESPONSE_CODE.SUCCESS) {
        const { records } = data
        this.provinceList = records
        fillBackProvince()
      } else {
        this.$message.success(msg)
      }
    },
    // 获取市区数据
    async getCityList(parentId) {
      // 如果缓存中存在市列表从缓存中取
      const fillBackCity = () => {
        this.cityList.map(item => (item.isSelectActive = false))
        const obj = this.cityList.find(item => item.id === this.cityId)
        if (obj) obj.isSelectActive = true
        if (this.areaId) {
          this.getAreaList(this.cityId)
        } else if (this.provinceId && this.cityId) {
          this.valueInput = `${this.provinceName} / ${this.cityName} ${this.citySplitStr}`
        }
      }
      const cacheCityList = this.cacheAreaMap[parentId]

      this.cityList = []
      if (cacheCityList) {
        this.cityList = cacheCityList
        fillBackCity()
        return
      }
      const { data, code, msg } = await sysArea({ parentId })
      if (code === RESPONSE_CODE.SUCCESS) {
        const { records } = data
        this.cityList = records
        this.cacheAreaMap[parentId] = records
        fillBackCity()
      } else {
        this.$message.success(msg)
      }
    },
    // 获取区县数据
    async getAreaList(parentId) {
      const fillBackArea = () => {
        this.areaList.map(item => (item.isSelectActive = false))
        if (this.areaId) {
          const obj = this.areaList.find(item => item.id === this.areaId)
          if (obj) obj.isSelectActive = true
          this.valueInput = `${this.provinceName} / ${this.cityName} / ${this.areaName}`
          this.updataValue(this.addressInfo)
        }
      }
      const cacheAreaList = this.cacheAreaMap[parentId]

      this.areaList = []
      if (cacheAreaList) {
        this.areaList = cacheAreaList
        fillBackArea()
        return
      }
      const { data, code, msg } = await sysArea({ parentId })
      if (code === RESPONSE_CODE.SUCCESS) {
        const { records } = data
        this.areaList = records
        this.cacheAreaMap[parentId] = records
        fillBackArea()
      } else {
        this.$message.success(msg)
      }
    },
    // 选中
    selectListClick(id) {
      const showLevel = parseInt(this.showLevel)
      const { provinceIdProp, provinceNameProp, cityIdProp, cityNameProp, areaIdProp, areaNameProp } = this.initAddressData.formProps
      if (this.typeClass === 0) {
        if (this.showLevel !== 1) {
          this.getCityList(id)
        }
        this.provinceList.map(item => (item.isSelectActive = false))
        this.initData[2].disable = true
        const obj = this.provinceList.find(item => item.id === id)
        if (obj) {
          obj.isSelectActive = true
          this.addressInfo[provinceIdProp] = obj.id
          this.addressInfo[provinceNameProp] = obj.nativeName
          this.addressInfo[cityIdProp] = ''
          this.addressInfo[cityNameProp] = ''
          this.addressInfo[areaIdProp] = ''
          this.addressInfo[areaNameProp] = ''
          this.initData[1].disable = false

          this.updataValue(this.addressInfo)
        }
        if (showLevel === 1) this.hideModal()
        if (showLevel > 1) this.clickTab(1)
        this.valueInput = `${obj.nativeName}`
      } else if (this.typeClass === 1) {
        if (this.showLevel !== 2) {
          this.getAreaList(id)
        }
        this.cityList.map(item => (item.isSelectActive = false))
        const obj = this.cityList.find(item => item.id === id)
        if (obj) {
          obj.isSelectActive = true
          this.addressInfo[cityIdProp] = obj.id
          this.addressInfo[cityNameProp] = obj.nativeName
          this.addressInfo[areaIdProp] = ''
          this.addressInfo[areaNameProp] = ''
          this.initData[2].disable = false
          this.valueInput = showLevel === 2 ? `${this.provinceName} / ${this.cityName}` : `${this.provinceName} / ${this.cityName} / `
          this.updataValue(this.addressInfo)
        }
        if (showLevel === 2) this.hideModal()
        if (showLevel > 2) this.clickTab(2)
      } else {
        this.areaList.map(item => (item.isSelectActive = false))
        const obj = this.areaList.find(item => item.id === id)
        if (obj) {
          obj.isSelectActive = true
          this.addressInfo[areaIdProp] = obj.id
          this.addressInfo[areaNameProp] = obj.nativeName
          this.valueInput = `${this.provinceName} / ${this.cityName} / ${this.areaName}`
          this.isShow = false
          this.clickTab(0)
          this.updataValue(this.addressInfo)
        }
      }
    },
    // / 传递选中的值到父组件
    updataValue(addressInfo) {
      const data = addressInfo
      // const data = this.getAddrData(addressInfo)
      this.$parent.clearValidate && this.$parent.clearValidate()
      this.$emit('input', data)
      this.$emit('change', data)
      this.$emit('changeValue', data)
    },
    getAddrData(addressInfo) {
      const { provinceIdProp, provinceNameProp, cityIdProp, cityNameProp, areaIdProp, areaNameProp } = this.initAddressData.formProps
      const data = {}
      data[provinceIdProp] = addressInfo.provinceId
      data[provinceNameProp] = addressInfo.provinceName
      data[cityIdProp] = addressInfo.cityId
      data[cityNameProp] = addressInfo.cityName
      data[areaIdProp] = addressInfo.areaId
      data[areaNameProp] = addressInfo.areaName
      return data
    },
    // 清空选中
    clearInput() {
      setTimeout(() => {
        this.provinceList.forEach(item => { item.isSelectActive = false })
        this.cityList.forEach(item => { item.isSelectActive = false })
        const { clientWidth } = this.$refs.pList[0]
        this.lineWidth = clientWidth
        this.lineLeftW = 10
        this.defaultDataLen = false
        this.valueInput = ''
        this.typeClass = 0
        this.initData.forEach(item => {
          item.disable = true
          item.isActive = false
        })
        Object.values(this.initAddressData.formProps).forEach(prop => {
          this.addressInfo[prop] = ''
        })
        this.initData[0].disable = false
        this.initData[0].isActive = true
        this.$emit('input', this.addressInfo)
        this.$emit('change', this.addressInfo)
        this.$emit('changeValue', this.addressInfo)
      }, 10)
    }
  }
}
</script>
<style lang="scss">
@mixin  arrow-color(){
  @each $themename , $theme in $themes {
    [data-theme = '#{$themename}'] & {
      border-color: transparent transparent map-get($map: $theme, $key: bg-color-pop);
    }
  }
}
$selectH: 360px;
.cp-input {
  .el-icon-circle-close {
    display: none;
    position: absolute;
    top: 10px;
    right: 6px;
    // background: #fff;
    @include bg-color('light');
  }
  &:hover {
    .el-icon-circle-close {
      display: inline;
    }
  }
}
.el-form-item.is-error {
  .cp-input {
    .el-icon-circle-close {
      display: none;
    }
    &:hover {
      .el-icon-circle-close {
        display: none;
      }
    }
  }
}
.custom-province {
  position: relative;
  .el-icon-loading {
    position: absolute;
    transform: translateX(-50%);
    left: 50%;
    top: 50px;
    margin-left: -10px;
    font-size: 20px;
  }
  .el-select__caret {
    transform: rotateZ(180deg);
    transition: transform 0.3s;
    cursor: pointer;
  }
  span,
  .el-input__suffix {
    cursor: pointer;
  }
  .el-scrollbar__wrap {
    overflow: auto;
    // max-height: $selectH;
    height: $selectH;
    min-width: 200px;
  }
  div {
    box-sizing: border-box;
  }
  .disable {
    opacity: 0.5;
    cursor: not-allowed !important;
  }
  .cp-modal {
    position: absolute;
    // background: #ffffff;
    width: 100%;
    // height: $selectH;
    z-index: 9999;
    top: 45px;
    border-radius: $radius-base;
    // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    // border: 1px solid #dddddd;
    @include bg-color('pop');
    @include shadow-color();
    @include border-color('pop');
    .popper__arrow {
      border-width: 6px;
      // @include el-select-base('bg');
      // @include bg-color('pop');
      position: absolute;
      left: 35px;
      top: -11px;
      width: 0;
      height: 0;
      border: 6px solid;
      // border-color: transparent transparent red;
      border-color: transparent;
      // border-bottom-color: transparent !important;
      // @include arrow-color();
      @include border-color('pop', 'bottom');
      &::after {
        top: 1px;
        margin-left: -6px;
        border-top-width: 0;
        // border-bottom-color: #FFF;
        @include border-color('pop', 'bottom');
      }
    }
    .cpm-ul {
      display: flex;
      height: 34px;
      align-items: center;
      border-bottom: 1px solid;
      @include border-color('lighter');
      padding: 0 10px;
      position: relative;
      .isActive {
        color: $-color-brand !important;
        font-weight: bolder;
      }
      .cpml-line {
        width: 50px;
        height: 2px;
        transform: rotateZ(180deg);
        transition: transform 0.3s;
        @include base-color('bg');
        position: absolute;
        bottom: -1px;
        left: 0;
      }
      .cpml-li {
        cursor: pointer;
        margin-left: 20px;
        // color: #999999;
        @include text-color('routine');
        font-size: 14px;
        &:first-child {
          margin-left: 0;
        }
      }
    }
    .cpm-content {
      .base-address-cader__wrap {
        margin-bottom: 0 !important;
      }
      // padding-top: 5px;
      .cpmc-li {
        width: 100%;
        padding-left: 20px;
        color: #999999;
        font-size: 12px;
        height: 32px;
        line-height: 32px;
        cursor: pointer;
        &:last-child {
          margin-bottom: 12px;
        }
        &:hover {
          @include bg-color('pop-active');
        }
      }
      .hover-item {
        @include bg-color('pop-active');
      }
      .isSelectActive {
        color: $-color-brand;
        @include bg-color('pop-active');
      }
    }
  }
}
</style>
